import {
  PostApiSpoCharacteristicProfileBody,
  SpoCharacteristicProfileResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getCharacteristicProfile = async (
  PostApiSpoCharacteristicProfileBody: PostApiSpoCharacteristicProfileBody,
): Promise<SpoCharacteristicProfileResponse> => {
  return apiBff.callBFF(
    'POST',
    'spo/characteristic_profile',
    PostApiSpoCharacteristicProfileBody,
  );
};
